export default __webpack_public_path__ + "b63ca83d7ad672324046dfe4d0aec069.webp";